export default {
    page_title: "Kevi | Lista de Cupones",
    title: "Cupones",
    export_aria_label: "Exportar cupones",
    export_button: "Exportar",
    table: {
        coupon: "Cupón",
        client: "Cliente",
        phone: "Teléfono",
        email: "Correo electrónico",
        created_at: "Fecha de creación",
        validity_between: "Validez Entre",
        used_at: "Usado en",
        automation: "Automatización",
    },
    badges: {
        used: "Utilizado:",
        expired: "Vencido",
        valid_until: "Válido hasta",
    },
    empty: {
        no_name: "Nombre no informado",
        not_used: "No utilizado",
        no_automation: "Creado sin automatización",
        no_data_for_period: "Sin datos para el período",
    },
    filters: {
        client_segment: "Segmento del cliente",
        coupon_code: "Código del cupón",
        created_date: "Fecha de creación",
        expiration_date: "Fecha de validez",
        used_date: "Fecha de uso",
        automation: "Automatización",
        status: "Situación",
        available: "Disponible",
        used: "Utilizado",
        expired: "Vencido",
    },
    export: {
        status_before_validity: "Antes de la Validez",
        status_used: "Utilizado",
        status_expired: "Expirado",
        status_valid: "Válido",
        column_code: "Código",
        column_coupon: "Cupón",
        column_status: "Situación",
        column_valid_from: "Inicio de la Validez",
        column_valid_until: "Fin de la Validez",
        column_used_at: "Usado en",
        column_client_name: "Nombre del Cliente",
        column_client_phone: "Teléfono del Cliente",
        column_client_email: "Correo electrónico del Cliente",
        column_automation: "Automatización",
    },
    conjunction_and: "y",
};
